export const MuiSelect = {
  // root: {
  //   width: '100%',
  //   height: '45px',
  //   fontSize: '13px',
  // },
  root: {
    border: '1px solid #d8dee3',
    borderRadius: 3,
    // height: '45px !important',
    // fontSize: '13px !important',
    // width: '100% !important',
  },
  // input: {
  // width: '100%',
  // height: '45px',
  // fontSize: '13px',
  // color: '#6d747b',
  // paddingTop: '0px',
  // paddingBottom: '0px',
  // '&:hover fieldset': {
  //   borderColor: '#b6b6b6',
  //   borderWidth: '1px',
  // },
  // '&.Mui-focused fieldset': {
  //   borderWidth: '1px',
  //   borderColor: '#b6b6b6',
  // },
  // '&[class*="MuiInputBase-root"]': {
  // width: '100%',
  // },
  // },
  // option: {
  //   fontSize: '13px',
  //   color: '#6d747b',
  // },
};

export const MuiInputLabel = {
  root: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: '11px',
    color: '#969ea5',
    marginBottom: '7px',
  },
};
